/*
 app dependencies
 -

 lib dependencies
 - jquery
*/

const scStatementsSlider = (function($)
{
    const   _sliderWraps = document.querySelectorAll('.js-statements-slider');

	//module functions
	function init()
	{
        if (!_sliderWraps.length) return;

		for (const sliderWrap of _sliderWraps)
        {
            _initSlider(sliderWrap);
        }
	}

    function _initSlider(sliderWrap)
    {
        $(sliderWrap).slick({
            arrows: false,
            //fade: true,
            dots: true
        });
    }

	//reveal public vars and functions
	return {
		//vars

		//functions
		init
	};

})(jQuery);
